const Address = require('./Address');
const AgeGroup = require('./AgeGroup');
const AdminUnit = require('./AdminUnit');
const Center = require('./Center');
const CenterQuestion = require('./CenterQuestion');
const Child = require('./Child');
const Classroom = require('./Classroom');
const Contract = require('./Contract');
const Coupon = require('./Coupon');
const {CenterDisplayOptions, CommissionRate, DashboardTip, DevelopmentStage,
  SeatAnalysis, SeatHistory, SeatPreference} = require('./Interfaces');
const Lead = require('./Lead');
const LegUpList = require('./LegUpList');
const Navigator = require('./Navigator');
const Parent = require('./Parent');
const Partner = require('./Partner');
const Payment = require('./Payment');
const Priority = require('./Priority');
const Program = require('./Program');
const Provider = require('./Provider');
const ProviderFile = require('./ProviderFile');
const Schedule = require('./Schedule');
const Seat = require('./Seat');
const Source = require('./Source');
const Tour = require('./Tour');
const TourRequest = require('./TourRequest');
const TourSchedule = require('./TourSchedule');
const User = require('./User');
const WaitlistSpot = require('./WaitlistSpot');
const AuthToken = require('./AuthToken');

const LegUpModel = {
  Address,
  AgeGroup,
  AdminUnit,
  Center,
  CenterQuestion,
  Child,
  Classroom,
  Contract,
  Coupon,
  CenterDisplayOptions, CommissionRate, DashboardTip, DevelopmentStage,
  SeatAnalysis, SeatHistory, SeatPreference,
  Lead,
  LegUpList,
  Navigator,
  Parent,
  Partner,
  Payment,
  Priority,
  Program,
  Provider,
  ProviderFile,
  Schedule,
  Seat,
  Source,
  Tour,
  TourRequest,
  TourSchedule,
  User,
  WaitlistSpot,
  AuthToken,
};

module.exports = LegUpModel;
